const mockInvoiceRecords = [
  {
    id: 101,
    invoice_id: 'INV-202602-001',
    status: '1',
    can_apply: 1,
    invoice_month: '2026年02月',
    settled_amount_tax: 100,
    refund_amount_tax: 30,
    invoice_amount: 70,
    invoice_type_text: '普票',
    invoice_title: '杭州红订单科技有限公司',
    invoice_subject: '厦门畅联影务有限公司',
    invoice_tax_no: '91330100MA2L9A0001',
    subject_tax_no: '91350203MA8F9B0001',
    submit_invoice_time: '2026-03-29 12:13:45',
    invoice_time: '',
    download_url: ''
  },
  {
    id: 102,
    invoice_id: 'INV-202601-002',
    status: '1',
    can_apply: 1,
    invoice_month: '2026年01月',
    settled_amount_tax: 88.5,
    refund_amount_tax: 8.5,
    invoice_amount: 80,
    invoice_type_text: '专票',
    invoice_title: '上海晨星数字科技有限公司',
    invoice_subject: '厦门畅联影务有限公司',
    invoice_tax_no: '91310000MA1A2B0002',
    subject_tax_no: '91350203MA8F9B0001',
    submit_invoice_time: '2026-03-28 09:05:21',
    invoice_time: '',
    download_url: ''
  },
  {
    id: 103,
    invoice_id: 'INV-202512-003',
    status: '2',
    can_apply: 0,
    invoice_month: '2025年12月',
    settled_amount_tax: 120,
    refund_amount_tax: 20,
    invoice_amount: 100,
    invoice_type_text: '专票',
    invoice_title: '深圳易达网络有限公司',
    invoice_subject: '厦门畅联影务有限公司',
    invoice_tax_no: '91440300MA5F1C0003',
    subject_tax_no: '91350203MA8F9B0001',
    submit_invoice_time: '2026-03-27 13:15:11',
    invoice_time: '',
    download_url: ''
  },
  {
    id: 104,
    invoice_id: 'INV-202511-004',
    status: '3',
    can_apply: 0,
    invoice_month: '2025年11月',
    settled_amount_tax: 76,
    refund_amount_tax: 6,
    invoice_amount: 70,
    invoice_type_text: '普票',
    invoice_title: '广州星桥信息技术有限公司',
    invoice_subject: '厦门畅联影务有限公司',
    invoice_tax_no: '91440100MA59D40004',
    subject_tax_no: '91350203MA8F9B0001',
    submit_invoice_time: '2026-03-25 18:20:32',
    invoice_time: '2026-03-30 10:02:49',
    download_url: 'https://example.com/invoice/INV-202511-004.pdf'
  }
]

function getPagedMockList(query) {
  const queryStatus = String(query.status || '')
  const currentPage = Number(query.page || 1)
  const pageSize = Number(query.pagesize || 10)
  const filteredRecords = queryStatus
    ? mockInvoiceRecords.filter((record) => String(record.status) === queryStatus)
    : mockInvoiceRecords
  const startIndex = (currentPage - 1) * pageSize
  const pageList = filteredRecords.slice(startIndex, startIndex + pageSize)
  return {
    code: 200,
    data: {
      list: pageList,
      total: filteredRecords.length
    }
  }
}

export function getInvoiceList(data = {}) {
  return Promise.resolve(getPagedMockList(data))
}

export function applyInvoice(data = {}) {
  return Promise.resolve({
    code: 200,
    data: {
      invoice_id: data.invoice_id || '',
      status: '2'
    },
    message: 'success'
  })
}



// WEBPACK FOOTER //
// ./src/api/invoice.js